module.exports = __webpack_public_path__ + "img/18.68d72a32.png";